// extracted by mini-css-extract-plugin
export default {"facetMenu":"ru-z","fixed":"su-z","nonLayerdFacets":"tu-z","productCount":"uu-z","facetBack":"vu-z","arrow":"wu-z","facetClose":"xu-z"};